import { z } from "zod";

import { zRelativePercent } from "~/shared/zod";

const zOut = z.object({
  ordersToday: zProperty(z.number().int().nonnegative()),
  newOrders: zProperty(z.number().int().nonnegative()),
  completedOrders: zProperty(z.number().int().nonnegative()),
  revenue: zProperty(z.number().nonnegative()),
});
type Out = z.infer<typeof zOut>;

function zProperty<T extends z.ZodSchema>(schema: T) {
  return z.object({
    value: schema,
    relativeToYesterday: zRelativePercent,
  });
}

export { zOut };
export type { Out };
